<template>
  <div>
    <section class="py-6">
      <b-container >
          <h2 class="h2 font-weight-900 pb-3 pt-3 d-lg-none">TA VIE CHEZ ASTEK</h2>
          <b-row>
            <b-col lg="6" md="12" class="order-2 order-lg-1">
              <b-card class="shadow">
                <span class="h2 font-weight-900 mb-0 d-none d-lg-block">{{ $t('magazines.titre') }}</span>
                <div class="row">
                  <div class="col-3">
                  </div>
                  <div class="col-9 col-lg-12 text-left text-lg-center">
                    <span class="h2 font-weight-900 mb-0 d-lg-none">MAGAZINES</span>
                  </div>
                </div>
                <b-row align="center" class="pt-3">
                  <b-col lg="6" md="12">
                      <b-link :href="data.home.mag_1.url" target="_blank">
                        <div class="row magazine">
                            <div class="col-3 col-lg-12">
                              <b-img class="d-none d-lg-block" alt="..." :src="'./img/theme/magazines/welcome_' + getLanguage + '.png'" />
                              <b-img class="d-block d-lg-none mt-3" alt="..." src="./img/theme/magazines/magazine.png" />
                            </div>
                            <div class="col-9 col-lg-12 text-left text-lg-center">
                              <h4 v-html="$t('magazines.mag-1.titre')"></h4>
                              <p v-html="$t('magazines.mag-1.description')"></p>
                            </div>
                        </div>
                      </b-link>
                  </b-col> 
                  <b-col lg="6" md="12">
                      <b-link :href="data.home.mag_2.url" target="_blank">
                        <div class="row magazine">
                            <div class="col-3 col-lg-12">
                              <b-img class="d-none d-lg-block" alt="..." src="./img/theme/magazines/manifest.png" />
                              <b-img class="d-block d-lg-none mt-3" alt="..." src="./img/theme/magazines/magazine.png" />
                            </div>
                            <div class="col-9 col-lg-12 text-left text-lg-center">
                              <h4 v-html="$t('magazines.mag-2.titre')"></h4>
                              <p v-html="$t('magazines.mag-2.description')"></p>
                            </div>
                        </div>
                      </b-link>
                  </b-col>                 
                </b-row>
                <b-row align="center" class="magazine">
                  <b-col lg="6" md="12">
                      <b-link :href="data.home.mag_3.url + getLanguage" target="_blank">
                        <div class="row magazine">
                            <div class="col-3 col-lg-12">
                              <b-img class="d-none d-lg-block" alt="..." :src="'./img/theme/magazines/res_' + getLanguage + '.png'" />
                              <b-img class="d-block d-lg-none mt-3" alt="..." src="./img/theme/magazines/magazine.png" />
                            </div>
                            <div class="col-9 col-lg-12 text-left text-lg-center">
                              <h4 v-html="$t('magazines.mag-3.titre')"></h4>
                              <p v-html="$t('magazines.mag-3.description')"></p>
                            </div>
                        </div>
                      </b-link>
                  </b-col> 
                  <b-col lg="6" md="12" class="magazine">
                      <b-link :href="data.home.mag_4.url + getLanguage" target="_blank">
                        <div class="row magazine">
                            <div class="col-3 col-lg-12">
                              <b-img class="d-none d-lg-block" alt="..." src="./img/theme/magazines/connekt.png" />
                              <b-img class="d-block d-lg-none mt-3" alt="..." src="./img/theme/magazines/magazine.png" />
                            </div>
                            <div class="col-9 col-lg-12 text-left text-lg-center">
                              <h4 v-html="$t('magazines.mag-4.titre')"></h4>
                              <p v-html="$t('magazines.mag-4.description')"></p>
                            </div>
                        </div>
                      </b-link>
                  </b-col>                 
                </b-row>              
              </b-card>
            </b-col>
            <b-col lg="6" md="12" class="order-1 order-lg-2">
              <b-row :key="item.id" v-for="(item, index) in apps">
                <b-col md="12" class="mb-lg-4 mb-3">
                  <b-card class="apps">
                    <b-link :href="data.home.apps[index].url" target="_blank">
                      <span class="h2 font-weight-900 mb-0 d-none d-lg-block" v-html="$t(item.title)"></span>
                      <b-row align-v="center" class="details">
                        <b-col align="center" align-v="center" cols="2" sm="3">
                          <i class="icon"><b-img class="" alt="..." :src="item.icon" /></i>
                        </b-col>
                        <b-col align="left" align-v="center" cols="10" sm="9" class="pl-1 pr-0">
                          <span class="h3 font-weight-900 mb-0 d-lg-none" v-html="$t(item.title)"></span>
                          <p v-html="$t(item.description)"></p>
                        </b-col>                      
                      </b-row>
                    </b-link>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>            
          </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import data from '../../../datas';

export default {
  name: 'Home',

  data() {
    return {
      data,
      apps: [
        {
          id: 1,
          title: "apps.app-1.title",
          description: "apps.app-1.description",
          icon: "./img/theme/apps/welcome.png"
        },
        {
          id: 2,
          title: "apps.app-2.title",
          description: "apps.app-2.description",
          icon: "./img/theme/apps/sharepoint.png"
        },
        {
          id: 3,
          title: "apps.app-3.title",
          description: "apps.app-3.description",
          icon: "./img/theme/apps/faq.png"
        }
      ]
    }
  },
  computed: {
    getLanguage: function() {
      //return localStorage.getItem(Vue.Keys.LANGUAGE);
      return Vue.i18n.locale();
    }
  }  
};
</script>
